import { createBrowserRouter } from 'react-router-dom';

// project-imports
import ChartMapRoutes from './ChartMapRoutes';
import FuzzScanRoutes from './FuzzScanRoutes';
import AuthRoutes from './AuthRoutes';
import AdminRoutes from './AdminRoutes';

import ProtectedRoute from 'components/ProtectedRoute';
import AdminRoute from 'components/AdminRoute';
import RouteError from 'components/RouteError';

// ==============================|| ROUTING RENDER ||============================== //

const router = createBrowserRouter(
  [
    {
      element: <ProtectedRoute />,
      errorElement: <RouteError />,
      children: [FuzzScanRoutes]
    },
    {
      // admin-only routes
      element: <AdminRoute />,
      errorElement: <RouteError />,
      children: [AdminRoutes]
    },
    { errorElement: <RouteError />, children: [AuthRoutes] },
    ChartMapRoutes
  ],
  {
    basename: import.meta.env.VITE_APP_BASE_NAME
  }
);

export default router;
